module.exports = __webpack_public_path__ + "img/gh-30282-6.prt.5d54d5ff.jpg";